module.exports = __webpack_public_path__ + "static/media/background-3258587_1920.782b874e.jpg";